import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { getDurationTime, formatDate } from '../../utils/date';

class Timer extends React.PureComponent {
  static formattedValue(seconds, format) {
    const duration = getDurationTime({ seconds });
    return formatDate(duration, format);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.initialSeconds !== prevState.initialSeconds) {
      return { seconds: nextProps.initialSeconds };
    }

    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      seconds: props.initialSeconds,
      initialSeconds: props.initialSeconds,
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  tick() {
    this.setState(prevState => ({
      seconds: prevState.seconds + 1,
    }));
  }

  render() {
    const { seconds } = this.state;
    const { format, ...props } = this.props;
    return (
      <StyledTimer key={seconds} {...props}>
        {Timer.formattedValue(seconds, format)}
      </StyledTimer>
    );
  }
}

Timer.propTypes = {
  initialSeconds: PropTypes.number,
  className: PropTypes.string,
  format: PropTypes.string,
};

Timer.defaultProps = {
  initialSeconds: 0,
  className: '',
  format: 'mm:ss',
};

const StyledTimer = styled.div`
  font-size: 17px;
  font-weight: bold;
`;

export default Timer;
